export default "__VITE_ASSET__Dpexz2do__"